module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-image-2-533x800-56015010ed14d4fbb92a5a4d4969dc40.jpg";